import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { OrderAction } from 'src/actions/order.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getOrderStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Select as Select1,
  MenuItem,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

const OrderLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.order);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(OrderAction.updateFilter(payload));
    dispatch(OrderAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedOrderIds;

    if (event.target.checked) {
      newSelectedOrderIds = items.map((order) => order.id);
    } else {
      newSelectedOrderIds = [];
    }

    setSelectedOrderIds(newSelectedOrderIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrderIds.indexOf(id);
    let newSelectedOrderIds = [];

    if (selectedIndex === -1) {
      newSelectedOrderIds = newSelectedOrderIds.concat(selectedOrderIds, id);
    } else if (selectedIndex === 0) {
      newSelectedOrderIds = newSelectedOrderIds.concat(selectedOrderIds.slice(1));
    } else if (selectedIndex === selectedOrderIds.length - 1) {
      newSelectedOrderIds = newSelectedOrderIds.concat(selectedOrderIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrderIds = newSelectedOrderIds.concat(
        selectedOrderIds.slice(0, selectedIndex),
        selectedOrderIds.slice(selectedIndex + 1)
      );
    }

    setSelectedOrderIds(newSelectedOrderIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, order) => {
    setSelected(order);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(OrderAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(OrderAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'da_thanh_toan') return 'green';
    else if (value == 'chua_thanh_toan') return 'red';
    else if (value == 'online') return 'green';
    else if (value == 'cod') return 'blue';
    else if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  const setTrangThaiThuTien = async (id, value) => {
    dispatch(OrderAction.update(id, { 
      trang_thai: value,
    }))
  }

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1500 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Thông tin khách hàng
                </TableCell>
                <TableCell>
                  Thông tin đặt hàng
                </TableCell>
                <TableCell>
                  Trạng thái
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((order, index) => (
                order ? <TableRow
                  hover
                  key={order.id}
                  selected={selectedOrderIds.indexOf(order.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    - <span style={{fontWeight: 'bold'}}>SĐT:</span> <span style={{color: 'blue', fontWeight: 'bold'}}>{order.phone}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Tên:</span> {order.name}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Địa chỉ:</span> {order.address}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Phương thức thanh toán:</span> <span style={{color: setColor(order.payment_method)}}>{order.payment_method == 'online' ? 'Chuyển khoản' : 'Khi nhận sim'}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Thời điểm đặt:</span> {moment(order.createdAt).format('DD-MM-YYYY HH:mm:ss')}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Ghi chú:</span> {order.note}<br></br>
                  </TableCell>
                  <TableCell>
                    - <span style={{fontWeight: 'bold'}}>Số sim:</span> <span style={{color: 'teal', fontWeight: 'bold'}}>{order.ordered_so_dien_thoai_co_dau_cham}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Giá bán:</span> {numeral(Number(order.ordered_gia_khach_hang_khuyen_mai) > 0 && Number(order.ordered_gia_khach_hang_khuyen_mai) < Number(order.ordered_gia_khach_hang) ? order.ordered_gia_khach_hang_khuyen_mai : order.ordered_gia_khach_hang).format('0,0')}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Nhà mạng:</span> <span style={{color: setColor(order.ordered_nha_mang)}}>{order.ordered_nha_mang}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Loại thuê bao:</span> {order.ordered_number_type == 1 ? 'TRẢ TRƯỚC' : (order.ordered_number_type == 2 ? 'TRẢ SAU' : '')}<br></br>
                  </TableCell>
                  <TableCell>
                    <Select1 
                      style={{
                          fontSize: '14px',
                          width: '200px',
                          marginBottom: '15px',
                          color: setColor(order.trang_thai)
                        }}
                        variant="outlined"
                        value={order.trang_thai}
                        onChange={(e) =>
                          setTrangThaiThuTien(order.id, e.target.value)
                        }
                      >
                      <MenuItem
                        style={{ color: setColor('da_thanh_toan') }}
                        value="da_thanh_toan"
                      >
                        Đã thanh toán
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('chua_thanh_toan') }}
                        value="chua_thanh_toan"
                      >
                        Chưa thanh toán
                      </MenuItem>
                    </Select1>
                  </TableCell>
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default OrderLookupDetail;
